import { includes } from 'libraries/lodash'
import {
  expandLegislationPath,
  $legislationGroup,
  requestAct,
  requestActVersions,
  editableActsMap
} from 'services/LegislationService'
import connect from 'front-end-core/decorators/connect'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import { User } from 'services/SessionService'
import ConnectedWrapper from 'pages/legislation/ConnectedWrapper'
import { map, filter } from 'rxjs/operators'

export const propsToStream = ({ act, scrollMain, editingId, aol }) => ({
  group: $legislationGroup(act.split(':')[0], null, editingId, aol),
  path: expandLegislationPath(act, aol),
  admin: User.pipe(map(({ roles }) => editableActsMap[act] && includes(roles, editableActsMap[act].editor))),
  publisher: User.pipe(map(({ roles }) => editableActsMap[act] && includes(roles, editableActsMap[act].publisher))),
  actSections: requestAct({ act, aol }),
  publishedId: requestAct({ act, aol }).pipe(
    filter(isValidResponse),
    map(({ versionId }) => versionId || false)
  ),
  versions: requestActVersions(act)
})

export default connect(propsToStream)(ConnectedWrapper)
